import { Alert, Box, Stack, Typography } from '@mui/material'

import { useGetBidSpreadAnalysisQuery } from 'generated/graphql'

import { BidSpreadAnalysisCard } from './BidSpreadAnalysisCard'
import { BidSpreadAnalysisFilterCriteria } from './BidSpreadAnalysisFilterCriteria'
import { BidSpreadAnalysisFiltersForm } from './BidSpreadAnalysisFilters'
import { useBidSpreadAnalysisQueryInput } from './useBidSpreadAnalysisQueryInput'

const BidSpreadAnalysisContent = () => {
  const { hasValidRange, input } = useBidSpreadAnalysisQueryInput()

  const { data, previousData, loading, error } = useGetBidSpreadAnalysisQuery({
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network',
  })

  const histogram = data?.bidSpreadAnalysis ?? previousData?.bidSpreadAnalysis

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box>
          <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
            Bid Spread Analysis
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            See how much bid prices vary per job over a selected time period, in both absolute and
            relative terms.
          </Typography>
        </Box>

        <BidSpreadAnalysisFiltersForm />
      </Stack>

      {error && (
        <Alert severity='error' sx={{ mb: 2 }}>
          Bid spread analysis failed to load. Please try again.
        </Alert>
      )}

      <BidSpreadAnalysisCard histogram={histogram} loading={loading && !histogram} />
    </Box>
  )
}

export const BidSpreadAnalysis = () => (
  <BidSpreadAnalysisFilterCriteria>
    <BidSpreadAnalysisContent />
  </BidSpreadAnalysisFilterCriteria>
)
